import * as React from "react";
function SvgFacebookPerson(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M15.22 16.9a5.14 5.14 0 10-3.88 0 7.72 7.72 0 00-5.77 7.46V25h4.57v-1.29H6.88a6.43 6.43 0 0112.79 0h-3.25V25H21v-.64a7.72 7.72 0 00-5.78-7.46zm-5.8-4.76A3.86 3.86 0 1113.28 16a3.86 3.86 0 01-3.86-3.86z" />
      <path d="M24.38 10a3.21 3.21 0 00-3.43 3.53v2h-2.3v2.67h2.3V25h2.75v-6.84H26l.34-2.67H23.7v-1.7c0-.77.21-1.3 1.32-1.3h1.41v-2.38a18.54 18.54 0 00-2.05-.11z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFacebookPerson);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
